  
<template>
    <el-dialog
        @close="change(false)"
        :visible="true"
        :width="`${width}px`"
        :title="title"
        :append-to-body="appendToBody"
        :close-on-click-modal="persistent || disabled"
    >
        <component
            v-if="['function', 'object'].includes(typeof message)"
            :is="message"
            v-bind="componentProps"
            :destroy="unset"
            :relax="relax"
            :busy="busy"
            @change-action-status="(val) => disabledAction = val"
            ref="my_component"
        ></component>
        <span v-else>{{message}}</span>
        <span slot="footer" v-if="showFooter" class="dialog-footer">
            <el-button
                v-if="Boolean(buttonFalseText)"
                :disabled="disabled"
                @click="choose(false) && !disabled"
            >{{buttonFalseText}}</el-button>
            <el-button
                type="primary"
                v-if="Boolean(buttonTrueText)"
                @click="choose(true)"
                :disabled="disabled || disabledAction"
                :loading="disabled"
            >{{buttonTrueText}}</el-button>
        </span>
    </el-dialog>
</template>

<script>
export default {
    props: {
        buttonTrueText: {
            type: String,
            default: 'Yes'
        },
        buttonFalseText: {
            type: String,
            default: 'No'
        },
        buttonTrueColor: {
            type: String,
            default: 'primary'
        },
        customComponent: Object,
        callback: Function,
        buttonFalseColor: {
            type: String,
            default: 'secondary'
        },
        showFooter: {
            type: Boolean,
            default: () => true
        },
        color: {
            type: String,
            default: 'warning'
        },
        icon: {
            type: String,
            default: 'warning'
        },
        message: {
            type: [String, Function, Object],
            required: true
        },
        persistent: Boolean,
        appendToBody: {
            type: Boolean,
            default: () => true
        },
        title: {
            type: String
        },
        width: {
            type: Number,
            default: 350
        },
        componentProps: Object,
        onCreated: Function
    },
    data() {
        return {
            value: false,
            disabled: false,
            disabledAction: false
        };
    },
    created() {
        // console.log('Test', this.message);
        // onCreated
        if (typeof this.onCreated === 'function') {
            this.onCreated(this)
        }
    },
    methods: {
        choose(value) {
            this.$emit('result', value);
            this.value = value;
            if (this.value && this.callback) {
                this.callback({
                    destroy: this.unset,
                    myComponent: this.$refs.my_component,
                    busy: this.busy,
                    relax: this.relax
                });
            } else {
                this.unset(value);
            }
        },
        unset(value) {
            this.value = value
            this.$destroy();
        },
        busy() {
            this.disabled = true;
        },
        relax() {
            this.disabled = false;
        },
        change(res) {
            this.unset(res);
        }
    }
};
</script>